import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import ConfigUrl, { axiosbaseurl } from "../../config"
import { notification } from "antd"
import { SiTicktick } from "react-icons/si"
import { IoMdWarning } from "react-icons/io"
import Loader from "pages/Loader"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"
import { FaChevronLeft, FaSave } from "react-icons/fa"

const AddUser = () => {

   document.title = "Staff | Return First Investments"

  const { checkAccess } = usePermissionData()

  const navigate = useNavigate()

  const [Loading, setLoading] = useState(false)

  const [Roles, setRoles] = useState([])

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`roles-and-permissions`)
      if (response?.data?.success) {
        setRoles(response?.data?.data)
      }
    } catch (e) {
      console.log("Error", e.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  // State for storing user photo and its preview URL
  const [UserPhoto, setUserPhoto] = useState(null)
  const [UserPhotoPreview, setUserPhotoPreview] = useState(null)

  // Handle image change
  const handleImageChange = e => {
    const file = e.target.files[0]
    if (file) {
      setUserPhoto(file)
      setUserPhotoPreview(URL.createObjectURL(file)) // Generate preview URL
    }
  }

  const [user, setUser] = useState({
    UserName: "",
    Email: "",
    Phone: "",
    Password: "",
    ConfirmPassword: "",
    Role: "",
  })

  // Error state for validation
  const [errors, setErrors] = useState({})

  // Handle input change
  const handleChange = e => {
    const { name, value } = e.target
    setUser(prev => ({ ...prev, [name]: value }))
  }

  // Validation function
  const validate = () => {
    let tempErrors = {}
    if (!user.UserName.trim()) tempErrors.UserName = "User Name is required"
    if (!user.Role.trim()) tempErrors.Role = "User Role is required"
    if (!user.Email.trim()) {
      tempErrors.Email = "Email is required"
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.Email)) {
      tempErrors.Email = "Invalid email format"
    }
    if (!user.Phone.trim()) {
      tempErrors.Phone = "Phone number is required"
    } else if (!/^\d{10}$/.test(user.Phone)) {
      tempErrors.Phone = "Phone number must be 10 digits"
    }
    if (!user.Password.trim()) tempErrors.Password = "Password is required"
    if (!user.ConfirmPassword.trim()) {
      tempErrors.ConfirmPassword = "Confirm Password is required"
    } else if (user.Password !== user.ConfirmPassword) {
      tempErrors.ConfirmPassword = "Passwords do not match"
    }

    setErrors(tempErrors)
    return Object.keys(tempErrors).length === 0
  }

  // Handle form submission
  const handleSubmit = async () => {
    if (validate()) {
      try {
        setLoading(true)

        const Formdata = new FormData()
        Formdata.append("profilePhoto", UserPhoto)
        Formdata.append("userName", user?.UserName)
        Formdata.append("email", user?.Email)
        Formdata.append("password", user?.Password)
        Formdata.append("contactNumber", user?.Phone)
        Formdata.append("roleId", user?.Role)

        const response = await axiosbaseurl.post(`user-management`, Formdata)

        if (response?.data?.success) {
          setLoading(false)
          notification.open({
            message: (
              <div className="d-flex align-items-center">
                <div className="pr-20">
                  <SiTicktick className="text-success fs-4 me-2" />
                </div>
                <div className="succes-message">User Created Successfully.</div>
              </div>
            ),
            placement: "topRight",
          })

          setTimeout(() => {
            navigate(`${ConfigUrl.appurl}users`)
          }, 1000)
        } else {
          setLoading(false)
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-10">
                  <IoMdWarning className="text-danger" size={22} />
                </div>
                <div>Opps! Something went wrong.</div>
              </div>
            ),
          })
        }
      } catch (e) {
        setLoading(false)
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
          description: e?.response?.data?.message,
        })
      }
    }
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(4, 2)}>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Staff" breadcrumbItem="Add Staff" />

            <div className="card p-3">
              <div className="text-end">
                <button
                  className="btn edit-Button bg-success text-white me-3 rounded-5"
                  onClick={handleSubmit}
                >
                  <FaSave className="me-2" />
                  Submit
                </button>
                <button
                  className="btn delete-Button rounded-5"
                  onClick={() => navigate(-1)}
                >
                  <FaChevronLeft className="me-2" />
                  Back
                </button>
              </div>
              <div className="Line" />

              <div className="row my-3">
                <div className="form-group col-xl-7 col-12">
                  <label>
                    Profile Photo
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    placeholder="Enter Full name"
                    name="Profile Image"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </div>
                {UserPhotoPreview && (
                  <div className="col-xl-1">
                    <img
                      className="Profile-img"
                      src={UserPhotoPreview}
                      alt="User Preview"
                    />
                  </div>
                )}

                {/* User Name */}
                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Full Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Full name"
                    name="UserName"
                    value={user.UserName}
                    onChange={handleChange}
                  />
                  {errors.UserName && (
                    <span className="text-danger">{errors.UserName}</span>
                  )}
                </div>

                {/* Email */}
                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter email"
                    name="Email"
                    value={user.Email}
                    onChange={handleChange}
                  />
                  {errors.Email && (
                    <span className="text-danger">{errors.Email}</span>
                  )}
                </div>

                {/* Phone */}
                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Phone <span className="text-danger">*</span>
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="Enter phone number"
                    maxLength={10}
                    name="Phone"
                    value={user.Phone}
                    onChange={handleChange}
                  />
                  {errors.Phone && (
                    <span className="text-danger">{errors.Phone}</span>
                  )}
                </div>

                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Role <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    placeholder="Select Role"
                    name="Role"
                    value={user.Role}
                    onChange={handleChange}
                  >
                    <option value={0}>Select Role</option>
                    {Roles.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.roleName}
                      </option>
                    ))}
                  </select>
                  {errors.Role && (
                    <span className="text-danger">{errors.Role}</span>
                  )}
                </div>

                {/* Password */}
                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Password <span className="text-danger">*</span>
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter password"
                    name="Password"
                    value={user.Password}
                    onChange={handleChange}
                  />
                  {errors.Password && (
                    <span className="text-danger">{errors.Password}</span>
                  )}
                </div>

                {/* Confirm Password */}
                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Confirm Password <span className="text-danger">*</span>
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Confirm password"
                    name="ConfirmPassword"
                    value={user.ConfirmPassword}
                    onChange={handleChange}
                  />
                  {errors.ConfirmPassword && (
                    <span className="text-danger">
                      {errors.ConfirmPassword}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </Container>
        </div>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default AddUser
